import { Route, Routes } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader.js';
import Home from './pages/Home.js';

export default function App() {
  return (
    <>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  );
}
